import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'reducers';

/**
 * Memoized selector for the CustomerAssignUserAccounts component.
 * Consolidates 12 individual useSelector calls into one, reducing re-renders
 * by only recalculating when accountsStore or userStore change.
 */
export const selectCustomerAssignUserAccountsContext = createSelector(
  [
    (state: RootState) => state.userStore,
    (state: RootState) => state.accountsStore,
    (state: RootState) => (state as any).assignRolesList,
  ],
  (userStore, accountsStore, assignRolesList) => ({
    loggedInUser: userStore.loggedInUser,
    assignedAccountNumber: userStore.assignedAccountNumber,
    assignedGrandfatherClientNumber: userStore.assignedGrandfatherClientNumber,
    createUserLoading: userStore.createUserLoading,
    assignAccountsToUserLoading: userStore.assignAccountsToUserLoading,
    detailedUser: userStore.detailedUser,
    accounts: accountsStore.accounts,
    accountsSize: accountsStore.totalSize,
    isAccountsLoading: accountsStore.isLoading,
    isAccountsError: accountsStore.isError,
    assignRolesList: assignRolesList?.roles ?? [],
  })
);
